var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPopular = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 19,
  height: 20,
  fill: "none",
  overflow: "visible",
  viewBox: "0 0 19 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.5,
  d: "M14.808 6c-.317 1.117-1.157 3.155-3.287 4.343.788-1.895 1.147-3.984 0-6.257C10.742 2.55 8.807.932 7.7.102c-.317-.235-.748-.04-.809.348-.154.984-.748 2.683-2.857 4.773C1.557 7.67 0 10.169 0 12.616c0 2.837 1.782 6.411 4.567 7.22.451.133.81-.348.594-.758-2.242-4.147 1.752-7.608 1.752-7.608 0 5.12 2.304 8.53 5.755 8.53 1.915 0 5.755-1.137 5.755-7.394 0-3.676-1.771-5.878-2.785-6.84a.512.512 0 0 0-.85.225z"
})));
export default SvgPopular;